import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { Outlet } from "react-router-dom";
import api from "_config/api";
import { useEffect, useState } from "react";
import { ModalTermoAceite } from "components/Organismos/TermoAceite/ModalTermoAceite";

export const Protected = () => {
  const [isReady, setIsReady] = useState(false);
  const [hasToAcceptTerm, setHasToAcceptTerm] = useState(false);
  const authHeader = useAuthHeader();

  useEffect(() => {
    if (authHeader) {
      api.defaults.headers.common["Authorization"] = authHeader;

      api
        .post("api/v1/cidadao/identidade", null, {
          headers: {
            Authorization: authHeader
          }
        })
        .then((res) => {
          setIsReady(true);
          setHasToAcceptTerm(res.data.aceitarTermo);
        });
      setIsReady(true);
    }
  }, [authHeader]);

  function closeModalTerm() {
    setHasToAcceptTerm(false);
  }

  if (!isReady) {
    return null;
  }
  return (
    <>
      <ModalTermoAceite isOpen={hasToAcceptTerm} onClose={closeModalTerm} />
      <Outlet />
    </>
  );
};
